import { getSizeData, isNotifyMeAllowed, isMultiVariantProduct } from 'app/productDetails/productDetailsUtils';
import { SIZE_SELECTED, SIZE_DESELECTED } from 'app/productDetails/productDetailsConstants';
import {
  REQUEST_PRODUCTS,
  REQUEST_PREPEND_PRODUCTS,
  REQUEST_APPEND_PRODUCTS,
  RECEIVE_PRODUCTS,
  PREPEND_PRODUCTS,
  APPEND_PRODUCTS,
  UPDATE_PRODUCT_DETAILS,
  SET_REFERRER_PRODUCT,
  CLEAN_REFERRER_PRODUCT_ID,
  UPDATE_IN_WISHLIST_PRODUCTS,
  UPDATE_DISPLAYED_ITEMS,
  RECEIVE_PRODUCTS_ERROR,
} from './productListConstants';
import { SELECT_FILTER, CLEAR_FILTERS, REPLACE_FILTERS } from '../facetsList/facetsListConstants';
import { SELECT_SORTING } from '../sortDropdown/sortDropdownConstants';

const { pageFetchSize } = window.inlinePlp || {};

export const isFetching = (state = false, action) => {
  switch (action.type) {
    case REQUEST_PRODUCTS:
    case REQUEST_PREPEND_PRODUCTS:
    case REQUEST_APPEND_PRODUCTS:
      return true;
    case RECEIVE_PRODUCTS:
    case APPEND_PRODUCTS:
    case PREPEND_PRODUCTS:
      return false;
    default:
      return state;
  }
};

export const showLoader = (state = false, action) => {
  switch (action.type) {
    case REQUEST_PRODUCTS:
      return action.showLoader;
    case RECEIVE_PRODUCTS:
      return false;
    default:
      return state;
  }
};

const extendProductsData = (products, page = 0) => {
  const batchSize = products.length;
  const pageOfProduct = index => (batchSize > pageFetchSize ? Math.trunc(index / pageFetchSize) : page);
  return products.map((product, index) => ({
    ...product,
    selectedSize: null,
    page: pageOfProduct(index),
    disableNotifyMe: !isNotifyMeAllowed(product),
  }));
};

const setData = (initialItems, productId, extendData) => {
  const localItems = initialItems.slice();
  const productIndex = localItems.findIndex(item => item.id === productId);
  localItems[productIndex] = Object.assign({}, initialItems[productIndex], extendData);
  return localItems;
};

export const setProductDetails = (initialItems, action) => {
  const { productId, productDetails, productType } = action;
  const sizeData = getSizeData(productDetails);
  const isMultiVariant = isMultiVariantProduct(productType);
  const selectedSize = isMultiVariant ? {} : { selectedSize: sizeData[0], sizeSelectedItem: sizeData[0] };

  return setData(initialItems, productId, {
    details: {
      hasColours: productDetails.hasClassificationGroups,
      sizes: sizeData,
      hasStock: productDetails.hasStock,
    },
    ...selectedSize,
  });
};

export const setProductSize = (initialItems, action, isSelected) => {
  const { productId, selectedSize } = action;
  return setData(initialItems, productId, {
    selectedSize: isSelected ? selectedSize : null,
  });
};

export const products = (
  state = {
    items: [],
    sortFields: [],
    totalItems: 0,
    displayedItems: 0,
    error: null,
  },
  action
) => {
  switch (action.type) {
    case RECEIVE_PRODUCTS: {
      const newProducts = action.products || action.payload?.products || [];
      const newMetadata = action.searchMetadata || action.payload?.searchMetadata || {};

      return Object.assign({}, state, {
        items: extendProductsData(newProducts, action.page),
        sortFields: newMetadata.sortFields,
        totalItems: newMetadata.totalItems,
        displayedItems: state.totalItems === newMetadata.totalItems ? state.displayedItems : 0,
      });
    }
    case RECEIVE_PRODUCTS_ERROR: {
      return {
        ...state,
        error: true,
      };
    }
    case APPEND_PRODUCTS:
      return {
        ...state,
        items: [...state.items, ...extendProductsData(action.products, action.page)],
      };
    case PREPEND_PRODUCTS:
      return {
        ...state,
        items: [...extendProductsData(action.products, action.page), ...state.items],
      };
    case UPDATE_IN_WISHLIST_PRODUCTS:
      return {
        ...state,
        items: action.products,
      };
    case UPDATE_PRODUCT_DETAILS:
      return {
        ...state,
        items: setProductDetails(state.items, action),
      };
    case SIZE_SELECTED:
      return {
        ...state,
        items: setProductSize(state.items, action, true),
      };
    case SIZE_DESELECTED:
      return {
        ...state,
        items: setProductSize(state.items, action, false),
      };
    case UPDATE_DISPLAYED_ITEMS:
      return {
        ...state,
        displayedItems: action.displayedItems,
      };
    default:
      return state;
  }
};

export const visiblePages = (state = { first: 0, last: 0 }, action) => {
  switch (action.type) {
    case SET_REFERRER_PRODUCT:
      return { first: action.page, last: action.page };
    case REQUEST_APPEND_PRODUCTS:
      return { ...state, last: state.last + 1 };
    case REQUEST_PREPEND_PRODUCTS:
      return { ...state, first: state.first - 1 };
    case SELECT_FILTER:
    case REPLACE_FILTERS:
    case CLEAR_FILTERS:
      return { first: 0, last: 0 };
    case SELECT_SORTING:
      return { ...state, first: 0 };
    default:
      return state;
  }
};

export const referrerProductId = (state = '', action) => {
  switch (action.type) {
    case SET_REFERRER_PRODUCT:
      return action.productId;
    case SELECT_FILTER:
    case CLEAR_FILTERS:
    case SELECT_SORTING:
    case CLEAN_REFERRER_PRODUCT_ID:
      return '';
    default:
      return state;
  }
};
